import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from '../service/services'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      step: 1,
      time: 60,
      payload: {},
      step_process: ''
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState([
      'isLoading',
      'UUID',
      'lang',
      'IDWallet',
      'Mode',
      'Type',
      'SaleID',
      'SaleType',
      'PaymentType',
      'accessToken',
      'AmountPayment',
      'reponseStatus',
      'sale_info',
      'printer_step',
      'sale_pay',
      'transection_edc'
    ]),
    ...mapMutations(['onMessageWs', 'clearState'])
  },
  methods: {
    back() {
      this.Soundclick();
      this.$socket.sendObj({
        command: 'edc_cancel'
      })
      this.$store.state.printer_step = 4
      // this.$router.push({
      //   name: 'Type'
      // })
    },
    TimeOut() {
      if (this.$route.name === 'ProcessCredit') {
        this.tt = setInterval(function () {
          this.time--
          // console.log(this.time)
          if (this.time === 0) {
            clearInterval(this.tt)
            clearInterval(this.step_process)
            this.$store.state.printer_step = 4
            let text = ''
            let title = ''
            switch (this.lang) {
              case 0:
                text = 'You did not complete the transaction at the specified time.'
                title = 'Warning'
                break
              case 2:
                text = '您未在指定時間完成交易。'
                title = '通知'
                break
              default:
                text = 'ท่านไม่ได้ทำรายการตามเวลาที่กำหนด'
                title = 'แจ้งเตือน'
                break
            }
            Swal(
              title,
              text,
              'warning'
            )
            this.$router.push({
              name: 'CreditCard'
            })
          }
        }.bind(this), 1000)
      } else {
        clearInterval(this.tt)
        clearInterval(this.step_process)
      }
    },
    close_payment() {
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }

      if (this.SaleID == 1) {
        var mode = 'Deposit'
        var payment_type_text = 'Credit'
        var type_text = 'Credit'
        if (this.SaleType == 1) {
          switch (this.lang) {
            case 0:
              payment_type_text = 'Credit'
              type_text = 'Credit'
              mode = 'Deposit'
              break;
            case 1:
              payment_type_text = 'เครดิต'
              type_text = 'เติมเงิน Credit'
              mode = 'เติมเงิน'
              break;
            case 2:
              payment_type_text = 'Credit'
              type_text = 'Credit'
              mode = '存款'
              break;
          }
        }

        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ""
        }]
      }

      var saletype = ''
      switch (this.SaleID) {
        case 1:
          saletype = 'deposit_credit'
          break
        case 2:
          saletype = 'sale_credit'
          break
        case 3:
          saletype = ''
          break
        case 4:
          saletype = 'sale_credit'
          break
        case 5:
          saletype = 'sale_credit'
          break
        default:
          saletype = 'deposit'
          break
      }
      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.$store.state.txn_id
        this.status_partner = false
      } else {
        this.status_partner = true
      }
      var numberPhone = this.IDWallet.substring(1, this.IDWallet.length);
      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.$store.state.txn_id,
        type: saletype,
        partner: this.status_partner,
        member_phone: '+66' + numberPhone,
        member_name: '',
        amount: parseFloat(this.$store.state.total),
        payment_received: parseFloat(this.$store.state.AmountPayment),
        payment_change: 0,
        flag_member: this.$store.state.flag_member,
        payment: {
          currency: "THB",
          creditcard: {
            type: "paygym",
            amount: parseFloat(this.$store.state.AmountPayment)
          }
        },
        items: this.$store.state.sale_subs
      }
      console.log(this.payload)
      api.closeSaleCredit(
        this.payload,
        header,
        result => {
          if (result.response == 'success') {
            var data_slip = {
              "command": "print_slip",
                "data": {
                  "client_tax_id": "",
                  "shop_title": this.$store.state.config.client.shop_title,
                  "shop_website": this.$store.state.config.client.shop_website,
                  "logo_image_width": 300,
                  "total": parseFloat(this.$store.state.total),
                  "payment": parseFloat(this.$store.state.AmountPayment),
                  "change": 0,
                  "type": "take_home",
                  "unchange": 0,
                  "status": 0,
                  "queue_no": result.queue,
                  "sale_pay": {
                    "B1000": this.sale_pay.b1000,
                    "B500": this.sale_pay.b500,
                    "B100": this.sale_pay.b100,
                    "B50": this.sale_pay.b50,
                    "B20": this.sale_pay.b20,
                    "C10": this.sale_pay.c10,
                    "C5": this.sale_pay.c5,
                    "C2": this.sale_pay.c2,
                    "C1": this.sale_pay.c1,
                  },
                  "sale_subs": this.$store.state.sale_subs_slip
                }
            }
            console.info(JSON.stringify(data_slip))
            this.$socket.sendObj(data_slip)
            const obj = {
              ref_number: this.$store.state.ref_number,
              status: 'PROCESSING'
            }
            api.getReceiveC9(obj, header,
              result => {
                console.log(result)
                this.step = 2
                setTimeout(function () {
                  this.$store.commit('clearState')
                  switch (this.lang) {
                    case 0:
                      this.sayLang('Thankyou')
                      break
                    case 2:
                      this.sayLang('謝謝')
                      break
                    default:
                      this.sayLang('ขอบคุณค่ะ')
                      break
                  }
                  // this.$router.push({
                  //   name: 'Main'
                  // })
                }.bind(this), 2500)
              }, error => {
                alert(JSON.stringify(error))
              }
            )
            if (this.$store.state.acl === 1) {
              this.$socket.sendObj({
                command: 'open_cash_box',
                data: 10
              })
            }
            this.$store.state.isLoading = false
            api.SaleCreditConfirm(
              this.transection_edc,
              header,
              result => {
                if (result.response == "success") {
                  console.log("Trancaction ETC Success")
                  setTimeout(() => {
                    this.$router.push({
                      name: 'Main'
                    })
                  },3000)
                }
              },
              error => {
                alert(JSON.stringify(error))
              }
            )
          }
        },
        error => {
          console.log(JSON.stringify(error))
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
          // this.$router.push({
          //   name: 'Main'
          // })
        })
    },
  },
  mounted() {
    this.close_payment()
    // if (this.$store.state.SaleID == 2) {
    //   this.$store.state.AmountPayment = this.$store.state.total
    // }
    // this.step_process = setInterval(function () {
    //   if (this.$store.state.printer_step == 2) {
    //     clearInterval(this.step_process)
    //     clearInterval(this.tt)
    //     this.close_payment()
    //     setTimeout(function () {
    //       this.$store.state.printer_step = 1
    //       this.$store.commit('clearState')
    //       this.tt = ''
    //       this.time = 60
    //       this.$router.push({
    //         name: 'Main'
    //       })
    //     }.bind(this), 2500)
    //     // location.reload() //แก้พิมเบิ้ล
    //   } else if (this.$store.state.printer_step == 4) {
    //     this.$store.state.printer_step = 1
    //     this.$store.commit('clearState')
    //     clearInterval(this.step_process)
    //     clearInterval(this.tt)
    //     this.tt = ''
    //     this.time = 60
    //     this.$router.push({
    //       name: 'Main'
    //     })
    //   } else {
    //     console.log('-------------------------------------------------------------------------------')
    //   }
    //   // alert(this.$store.state.printer_step)
    // }.bind(this), 1000)
    // this.open_sale()
    // this.TESTProcess()
  }
}



// WEBPACK FOOTER //
// ./src/js/pcr.js